import React ,{ useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

const LinkList = () => {

  const {category} = useParams(); // URLからcategoryパラメータを取得
  const [links, setLinks] = useState({});
  const [error, setError] = useState(null);
  const [sortType, setSortType] = useState('new');
  
  useEffect(() => {
    // APIのエンドポイントを指定
    fetch(`/req_api/linklist.php?cat=${category}&sort=${sortType}`) 
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // 取得したJSONデータをstateにセット
        setLinks(data);
      })
      .catch(error => {
        setError(error);
        console.error('Error fetching links:', error);
      });
  }, [category,sortType]);

  return (
    <div>
      <p className="sort">       
          <span
            onClick={() => setSortType('new')}
            className={`new ${sortType === 'new' ? 'active' : ''}`}
          >
            新着順
          </span>
          ｜
          <span
            onClick={() => setSortType('click')}
            className={`click ${sortType === 'click' ? 'active' : ''}`}
          >
            人気順
          </span>
        </p>
    
        <ul id="categoryWrap">
          {Object.keys(links).map(key => (
              <li key={key}>            
                <a href={`/req_api/links.php?url=${links[key].site_url}`} target="_blank" rel="noopener noreferrer">            
                  <img 
                    src={links[key].site_img ? `/upload/${links[key].site_img}`: '/upload/no_img.png'}
                    alt={links[key].site_name} 
                  />            
                  <h3 className='ttl'>{links[key].site_name}</h3>
                  <p>{links[key].site_detail}</p>
                </a>
              </li>
          ))}
        </ul>
    </div>
  );
};

export default LinkList;